import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

export function getDocumentsStatus({
  documentId,
  workspaceId,
}: {
  documentId: string;
  workspaceId: string;
}): Promise<string> {
  return requestApi<{
    status: string;
  }>({
    url: withDocument(`/workspaces/${workspaceId}/documents/${documentId}/status`),
    method: 'GET',
    credentials: true,
  }).then((response) => response.data.status.toLowerCase());
}
